import { Component, input, model, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tabs-v2',
  imports: [TranslatePipe],
  templateUrl: './tabs-v2.component.html',
  styleUrl: './tabs-v2.component.scss'
})
export class TabsV2Component {
  tabs = input<{ id: number; label: string }[]>();
  selectedTab = model<number>();
  selectedTabChange = output<number>();

  onTabClick(tabId: number): void {
    if (this.selectedTab() === tabId) {
      return;
    }
    this.selectedTab.set(tabId);
    this.selectedTabChange.emit(tabId);
  }
}
